import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Mail/hooks/useMailMessage.ts
function useMailMessage(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Mail.GetMessage.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
export { useMailMessage };

//# sourceMappingURL=useMailMessage.js.map